var InitCreateAttributeModal = function (creationModal, productAttributeEnum, $) {
    creationModal.CreateAttributeModal = (function () {
        const fieldAttreRex = new RegExp("^[\\w\-\\s\/\\+\\.]{1,64}$");
        const errorAttrValidationMessage = "Attribute length cannot be more than 64. Attribute values can contain only the following characters: alphanumeric ('A-Z, 0-9'), space ' ', forward-slash '/', plus '+', hyphen '-', full stop '.' and underscore '_'";
        const fieldProductTypeRex = new RegExp("^[\\w\-\\s\/\\+\\.\\;\\:\\(\\)\\*\\&\\^\\%\\$\\#\\@\\,\\']{1,50}$");
        const errorProductTypeValidationMessage = "Product Type length cannot be more than 50. Product Type can contain only the following characters: alphanumeric ('A-Z, 0-9') and ,./;:-_ + () * &^%$#@'";

        const attributeField = '#new_product_attribute';
        const createAttrModal = '#create_product_attribute_modal';

        const addAttributeEndpoint = '/dotnet/admin/api/addproductattributevalue/';

        var openModal = function () {
            $(attributeField).val("");
            $(createAttrModal).modal('show');
        }

        var setTitle = function (title) {
            $('#create_product_attribute_title').text(title);
        }
        var setLabel = function (label) {
            $('#create_product_attribute_label').text(label);
        }
        var setSubmitModal = function (endpoint, dropdown, fieldRexExp, validMessage, callBack) {
            $('#create_product_attribute_submit').off('click')
                .click(createAttributeOnClick(endpoint, dropdown, fieldRexExp, validMessage, callBack));
        }

        var validateModal = function (regExp, validateMessage) {
            if ($(attributeField).val() === "") {
                alert("This field cannot be empty");
                return false;
            }

            if (!regExp.test($(attributeField).val())) {
                alert(validateMessage);
                return false;
            }
            return true;
        }

        var createAttributeOnClick = function (endpoint, dropdownSelector, fieldRexExp, validMessage, replaceCallback) {
            var onClickModal = function (e) {
                e.preventDefault();
                if (validateModal(fieldRexExp, validMessage)) {
                    $.ajax({
                        method: 'POST',
                        data: JSON.stringify({
                            Name: $(attributeField).val()
                        }),
                        url: window.location.origin + endpoint,
                        dataType: 'json',
                        contentType: 'application/json; charset=UTF-8',
                        success: function (newAttributeType) {
                            if (newAttributeType != null) {
                                if (newAttributeType.messageError == null) {
                                    if (replaceCallback) {
                                        replaceCallback(newAttributeType);
                                    }
                                    else {
                                        $('<option/>', {
                                            value: newAttributeType.id,
                                            html: newAttributeType.name,
                                            selected: 'true'
                                        }).appendTo(dropdownSelector);
                                    }
                                    $(createAttrModal).modal('hide');
                                    $(dropdownSelector).focus();
                                }
                            }
                        },
                        error: function (request, status, error) {
                            alert(request.responseJSON.exceptionMessage);
                        }
                    });
                }
            };
            return onClickModal;
        };

        var showCreateProductTypeModal = function (selector, callBack) {
            setTitle("Create Product Type");
            setLabel("Product Type");
            setSubmitModal("/dotnet/admin/api/addproducttype", selector, fieldProductTypeRex, errorProductTypeValidationMessage, callBack);
            openModal();
        }

        var showCreateBrandModal = function (selector, callBack) {
            setTitle("Create Brand");
            setLabel("Brand");
            setSubmitModal(addAttributeEndpoint + productAttributeEnum.Brand, selector, fieldAttreRex, errorAttrValidationMessage, callBack);
            openModal();
        }

        var showCreateCustomAttributeValueModal = function (selector, attributeName, attributeId, callBack) {
            setTitle("Create Custom Attribute Value");
            setLabel(attributeName);
            setSubmitModal(addAttributeEndpoint + attributeId, selector, fieldAttreRex, errorAttrValidationMessage, callBack);
            openModal();
        }

        var showCreateSizeModal = function (selector, callBack) {
            setTitle("Create Size");
            setLabel("Size");
            setSubmitModal(addAttributeEndpoint + productAttributeEnum.Size, selector, fieldAttreRex, errorAttrValidationMessage, callBack);
            openModal();
        }
        var showCreateSeasonModal = function (selector, callBack) {
            setTitle("Create Season");
            setLabel("Season");
            setSubmitModal(addAttributeEndpoint + productAttributeEnum.Season, selector, fieldAttreRex, errorAttrValidationMessage, callBack);
            openModal();
        }
        var showCreateColourModal = function (selector, callBack) {
            setTitle("Create Colour");
            setLabel("Colour");
            setSubmitModal(addAttributeEndpoint + productAttributeEnum.Colour, selector, fieldAttreRex, errorAttrValidationMessage, callBack);
            openModal();
        }
      
        $(document).off('shown.bs.modal', createAttrModal).on('shown.bs.modal', createAttrModal, function () {
            $(attributeField).focus();
        });

        $(document).off('keypress', attributeField).on('keypress', attributeField, function (e) {
            if (e.which === 13) { //Enter
                $('#create_product_attribute_submit').click();
            }
        });

        return $.extend(creationModal.CreateAttributeModal, {
            ShowCreateProductTypeModal: showCreateProductTypeModal,
            ShowCreateBrandModal: showCreateBrandModal,
            ShowCreateSizeModal: showCreateSizeModal,
            ShowCreateSeasonModal: showCreateSeasonModal,
            ShowCreateColourModal: showCreateColourModal,
            ShowCreateCustomAttributeValueModal: showCreateCustomAttributeValueModal
        });
    })();

    return creationModal.CreateAttributeModal;
};
